const deployURL: string = "https://api.jamaicanstyledominoes.com"
const deployWSURL: string = "wss://api.jamaicanstyledominoes.com"
const deployFEURL: string = "https://jamaicanstyledominoes.com"

var serverURL: string = deployURL;
var serverWSURL: string = deployWSURL;
var feUrl: string = deployFEURL;
export  {feUrl, serverURL, serverWSURL };